<template>
	<div class="no-wrap has-background-white" style="width:100%; height: 90vh; overflow-x: hidden;">
        <div class="columns">
            <div class="column is-12">
				<div>
					<router-link :to="{ path: '/operation/create'}">
						<b-button size="large" type="is-info">CREATE</b-button>
					</router-link>
				</div>
				<base-table
					:service="$options.orderOperationService"
					fetch-func="all"
					:fetch-params="params"
					:columns="columns"
					default-sort-direction="desc"
					:narrowed="false"
					ref="baseTable"
					:sticky="true"
					>
					<template #rowCheckBox="{ row }">
						<b-checkbox></b-checkbox>
					</template>
					<template #rowFirmFirmId="{ row }">
						{{ row.firm_firm_id }}
					</template>
					<template #rowDescription="{ row }">
						{{ row.description }}
					</template>
					<template #rowTotal="{ row }">
						{{ getTotal(row) | numberPriceFormatterWithDollarSign }}
					</template>
					<template #rowAction="{ row }">
						<router-link :to="{ path: `/operation/update/${row.id}` }">
							<b-button type="is-info">
								VIEW
							</b-button>
							<b-button type="is-info">
								PRINT
							</b-button>
						</router-link>
					</template>
				</base-table>
            </div>
        </div>
    </div>
</template>
<script>
import BaseTable from "@/components/partials/BaseTable";
import { OrderOperationService } from "@/services/orderOperation.service";
export default {
	orderOperationService: OrderOperationService,
  	components: {
    	BaseTable
  	},
    data: () => ({
	    params: {
	    	includes: 'orderOperationClaimLines'
	    },
    }),
    computed: {
	    columns() {
	        let columns = [];
			columns.push({field: "id", label: "", meta: {
	            rowSlot: "rowCheckBox",
	        }});
	        columns.push({field: "id", label: "ID"});
			columns.push({field: "firm_firm_id", label: "Supplier", meta: {
	            rowSlot: "rowFirmFirmId",
	        }});
	        columns.push({field: "description", label: "Description", meta: {
	            rowSlot: "rowDescription",
	        }});
	        columns.push({field: "", label: "Total", meta: {
	            rowSlot: "rowTotal"
	        }});
	        columns.push({field: "status", label: "Status"});
	        columns.push({field: "", label: "", meta: {
	            rowSlot: "rowAction",
	            class: 'action-td'
	        }});
	        return columns;
	    }
	},
	methods: {
		fetch() {
			return this.$refs.baseTable.fetchData();
		},
		getTotal(row) {
			if (true) {}
			let x = row.orderOperationClaimLines.map(element => {
				if (element.orderOperationClaimService) {
					return element.quantity * element.orderOperationClaimService.rate
				}
				return 0;
			});
			if (x.length) {
				return x.reduce((a, b) => a + b);
			}
			return 0;
		}
	},
	mounted() {
		this.fetch();
	}
};
</script>
<style scoped>
	.fa-exclamation-circle{
		font-size: 18px;
		cursor: pointer;
	}
	.action-td{
		width: 100px;
	}
	.has-sticky-header{
		height: 83vh !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/pages/Operations/index.vue